<footer class="container-wrapper selenium-app-footer w-100" id="footer">
    <div
        [ngClass]="{
            'student-container': userService.hasStudentExperience(),
            'teacher-container pt-1 pb-5': !userService.hasStudentExperience()
        }"
        class="container"
    >
        <div
            [ngClass]="
                userService.hasStudentExperience()
                    ? 'justify-content-xs-center justify-content-md-between justify-content-lg-between'
                    : 'ml-0 flex-column justify-content-xs-between justify-content-md-center justify-content-lg-start'
            "
            class="row mx-xs-0 flex-lg-nowrap flex-lg-row justify-content-xs-center mt-xs-7 mt-sm-8"
        >
            <div
                [ngClass]="
                    userService.hasStudentExperience()
                        ? 'col-md-6 align-items-xs-center'
                        : 'col-md-4 col-sm-6 col-lg-4 align-items-sm-start'
                "
                class="mobile-top-section d-flex flex-column flex-nowrap align-items-xs-center align-items-md-start"
            >
                <div
                    *ngIf="!userService.hasStudentExperience() && !isAddonView"
                    class="student-view-button px-0 py-0 text-center d-xs-inline-block"
                >
                    <button
                        aria-label="Access student site"
                        class="{{
                            gtmPrefix + 'student-button ' + 'btn'
                        }} d-flex align-items-center font-weight-bold text-white button-spacing"
                        (click)="changeUserExperience(true, '_blank')"
                        rel="noopener noreferrer"
                    >
                        Student site
                        <em class="fas fa-external-link-alt ml-2"></em>
                    </button>
                </div>
                <div
                    class="in-partnership"
                    [ngClass]="{
                        'mt-7': !isAddonView,
                        'mt-5': isAddonView && userService.hasStudentExperience()
                    }"
                >
                    In partnership with
                </div>
                <div
                    class="logos d-inline-block position-relative flex-column d-md-grid align-middle align-items-center mb-2 mt-3 justify-content-between"
                >
                    <span
                        [attr.data-gtmlabel]="'PBS'"
                        class="{{ gtmPrefix + 'logo-pbs ' + 'logo-pbs' }} mt-1 h-100 mr-6 my-0 mb-3"
                        rel="noopener noreferrer"
                        [ngClass]="userService.hasStudentExperience() ? '' : 'mb-4'"
                    >
                        <img
                            [src]="pbsLogoWhite"
                            alt="PBS LearningMedia"
                            [ngClass]="userService.hasStudentExperience() ? '' : 'mr-6'"
                        />
                    </span>
                    <span
                        [attr.data-gtmlabel]="'WGBH'"
                        class="{{ gtmPrefix + 'logo-wgbh ' + 'logo-wgbh' }} mx-lg-1 my-0"
                    >
                        <img
                            alt="WGBH logo"
                            src="https://d43fweuh3sg51.cloudfront.net/defaults/wgbh-logo.svg"
                        />
                    </span>
                </div>
                <div
                    *ngIf="userService.hasStudentExperience()"
                    class="rights-reserved-student pb-6 text-xs-center text-md-left"
                >
                    &copy; {{ currentYear }} PBS &amp; GBH Educational Foundation. All rights
                    reserved.
                </div>
            </div>
            <div
                *ngIf="!userService.hasStudentExperience()"
                class="col-sm-6 col-lg-5 connect-with-us"
            >
                <section class="social-media">
                    <div class="social-media__inner py-0 px-0 my-0 mx-auto mb-xs-4">
                        <h3 class="footer-title text-uppercase">Connect With Us</h3>
                        <p class="sign-up-for mx-xs-0 mb-xs-3">
                            Sign up for our newsletter for the latest resources, news, and more.
                        </p>
                        <div class="input-group mb-xs-6">
                            <input
                                [ngClass]="{ 'invalid-email': !isEmailValid && email.length }"
                                class="form-control input-email rounded-0 text-white"
                                id="email-eloqua-newsletter"
                                placeholder="Your email"
                                (keyup)="validateEmail()"
                                required
                                title="Please enter a valid email address."
                                type="email"
                            />
                            <span class="input-group-btn input-group-append font-weight-bold">
                                <span
                                    [ngClass]="{ 'email-disabled-button': !isEmailValid }"
                                    (click)="subscribe()"
                                    [attr.data-gtmlabel]="'Go'"
                                    class="{{
                                        gtmPrefix +
                                            'newsletter-go ' +
                                            'input-group-text btn btn-success text-white button-spacing'
                                    }} font-weight-bold"
                                    id="eloqua-newsletter-go"
                                    >Sign up!</span
                                >
                            </span>
                        </div>
                        <span class="footer-social-links d-flex">
                            <a
                                class="social-media__link text-decoration-none d-inline-block"
                                title="Facebook"
                                href="https://www.facebook.com/pbsteachers"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <i class="fab fa-facebook-f pl-1 mx-0 my-0 text-white"></i>
                            </a>
                            <a
                                class="social-media__link text-decoration-none d-inline-block ml-md-9 ml-xs-7"
                                href="https://twitter.com/pbsteachers"
                                rel="noopener noreferrer"
                                title="Twitter"
                                target="_blank"
                            >
                                <i class="fab fa-twitter mx-0 my-0 text-white"></i>
                            </a>
                            <a
                                class="social-media__link text-decoration-none d-inline-block ml-md-9 ml-xs-7"
                                href="https://www.pinterest.com/pbslm/"
                                rel="noopener noreferrer"
                                title="Pinterest"
                                target="_blank"
                            >
                                <i class="fab pbslm-pinterest-simple mx-0 my-0 text-white"></i>
                            </a>
                            <a
                                class="social-media__link text-decoration-none d-inline-block ml-md-9 ml-xs-7"
                                href="https://www.instagram.com/pbs.teachers"
                                rel="noopener noreferrer"
                                title="Instagram"
                                target="_blank"
                            >
                                <i class="fab fa-instagram mx-0 my-0 text-white"></i>
                            </a>
                        </span>
                    </div>
                </section>
            </div>
            <!--            TODO: refactor footer links: replace a with app-link-->
            <div *ngIf="!userService.hasStudentExperience()" class="learn-more">
                <h3 class="footer-title text-uppercase">Learn More</h3>
                <ul class="list-unstyled py-0 px-0">
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <app-link
                            [appRouterLink]="isAddonView ? null : '/about/'"
                            [href]="isAddonView ? '/about/' : null"
                            [attr.data-gtmlabel]="'About'"
                            class="{{ gtmPrefix + 'help' }}"
                            [target]="'_blank'"
                            >About
                        </app-link>
                    </li>
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            [attr.data-gtmlabel]="'PBS Education'"
                            class="{{ gtmPrefix + 'pbs-education' }} text-white"
                            href="https://www.pbs.org/education/"
                            rel="noopener noreferrer"
                            target="_blank"
                            >PBS Education</a
                        >
                    </li>
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            (click)="openFeedbackForm($event)"
                            class="my-0 text-white"
                            href="#"
                            role="button"
                            >Contact Us</a
                        >
                    </li>
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            [attr.data-gtmlabel]="'Help'"
                            class="{{ gtmPrefix + 'help' }} text-white"
                            [target]="isAddonView ? '_blank' : '_self'"
                            href="/help/"
                            >Help</a
                        >
                    </li>
                </ul>
            </div>
            <div
                *ngIf="userService.hasStudentExperience()"
                [ngClass]="{ 'logged-in-user': userService.isLoggedIn() }"
                class="student-right-side justify-content-end d-flex flex-column justify-content-end align-middle align-items-center flex-nowrap"
            >
                <button
                    (click)="teacherLogin()"
                    *ngIf="!userService.isLoggedIn() && !isAddonView"
                    class="btn btn-primary mb-6 font-weight-bold"
                >
                    Teachers, sign in for resources
                </button>
                <button
                    *ngIf="userService.isLoggedIn() && !userService.isStudent() && !isAddonView"
                    class="btn btn-primary mb-6 font-weight-bold"
                    (click)="changeUserExperience(false, '_self')"
                >
                    Return to Teacher view
                </button>
                <div class="terms-and-privacy-policy">
                    <app-link
                        [appRouterLink]="isAddonView ? null : '/about/'"
                        [href]="isAddonView ? '/about/' : null"
                        [attr.data-gtmlabel]="'About'"
                        class="{{ gtmPrefix + 'about' }} my-2 mx-3"
                        [target]="'_blank'"
                        >About
                    </app-link>
                    <app-link
                        [appRouterLink]="isAddonView ? null : '/help/privacy-policy/'"
                        [href]="isAddonView ? '/help/privacy-policy/' : null"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        [target]="'_blank'"
                        >Privacy Policy</app-link
                    >
                    <app-link
                        [appRouterLink]="isAddonView ? null : '/help/terms-of-use/'"
                        [href]="isAddonView ? '/help/terms-of-use/' : null"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        [target]="'_blank'"
                        >Terms of Use</app-link
                    >

                    <app-link
                        [appRouterLink]="isAddonView ? null : '/help/'"
                        [href]="isAddonView ? '/help/' : null"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        [target]="'_blank'"
                        >Help</app-link
                    >
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!userService.hasStudentExperience()" class="copyright-wrapper">
        <div class="legal-and-contact py-4 px-0 text-center w-100">
            <div class="col-12">
                <div class="rights-reserved d-inline-block">
                    &copy; {{ currentYear }} PBS &amp; GBH Educational Foundation. All rights
                    reserved.
                </div>
                <div class="terms-and-privacy-policy d-inline-block">
                    <app-link
                        [appRouterLink]="isAddonView ? null : '/help/privacy-policy/'"
                        [href]="isAddonView ? '/help/privacy-policy/' : null"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        [target]="'_blank'"
                        >Privacy Policy</app-link
                    >
                    <span>|</span>
                    <app-link
                        [appRouterLink]="isAddonView ? null : '/help/terms-of-use/'"
                        [href]="isAddonView ? '/help/terms-of-use/' : null"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        [target]="'_blank'"
                        >Terms of Use</app-link
                    >
                </div>
            </div>
        </div>
    </div>
    <div
        aria-hidden="true"
        aria-labelledby="myModalLabel"
        class="modal fade"
        id="feedbackModal"
        role="dialog"
    >
        <div class="modal-dialog">
            <div class="modal-content"></div>
        </div>
    </div>
</footer>
